<template>
    <div class="relative">
        <span @click="toggleOptions" class=""><span v-if="username">{{ username | capitalize }}</span><span v-if="!username">Guest</span></span>
    </div>
</template>

<script>
export default {
    name: 'user-widget',
    data: function(){
        return {
            showOptions: true
        }
    },
    computed: {
        username: function(){
            return this.$store.state.authUser;
        }
    },
    methods: {
        
        toggleOptions: function(){
            this.showOptions = !this.showOptions;
        }
    }

}
</script>

<style>

</style>